import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { memo } from "react";
import { getExpandedItems } from "../../utils/outbound-labels-utils";

const catalogEntry = fgColumnEntries["on-hand-inventory"];

const OnHandInventoryCell = memo(function OnHandInventoryCell({
  row,
  expansionIndex,
}: {
  row: FulfillmentGroupData;
  expansionIndex: number;
}) {
  const item = getExpandedItems(row)[expansionIndex];
  if (!item) {
    return null;
  }
  return (
    <RedoTableTextCell
      text={item.onHandInventory == null ? "—" : String(item.onHandInventory)}
    />
  );
});

export const OnHandInventoryColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  // Single-item rows don't expand, so surface their inventory at the top level.
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => {
    if (getExpandedItems(row).length > 1) {
      return null;
    }
    return <OnHandInventoryCell expansionIndex={0} row={row} />;
  },
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => <OnHandInventoryCell expansionIndex={expansionIndex} row={row} />,
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
